import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../../shared/shared";
import {CourseService} from "../../../../service/CourseService";
import {BooleanComponent} from "../../generic/table/booleanComponent/booleanComponent";
import {CalendarComponent} from "../../generic/table/calendarComponent/calendarComponent";
import {TextComponent} from "../../generic/table/textComponent/textComponent";
import {DropdownComponent} from "../../generic/table/dropdownComponent/dropdownComponent";
import {ModalityEntity} from "../../../../model/ModalityEntity";
import {CourseTypeEntity} from "../../../../model/CourseTypeEntity";
import {CourseEntity} from "../../../../model/CourseEntity";
import {SiteEntity} from "../../../../model/SiteEntity";
import {TurnEntity} from "../../../../model/TurnEntity";
import {WorkgroupEntity} from "../../../../model/WorkgroupEntity";
import * as moment from 'moment-timezone';
import {ButtonComponent} from "../../generic/table/buttonComponent/buttonComponent";
import {BasicDto} from "../../../../dto/BasicDto";
import {ContextService} from "../../../../service/ContextService";
import {CourseFrontPageEntity} from "../../../../model/CourseFrontPageEntity";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {PermissionRoleEntity} from "../../../../model/PermissionRoleEntity";
import {CommonCourseDto} from "../../../../dto/CommonCourseDto";
import {StaticCalendarEntity} from "../../../../model/StaticCalendarEntity";

@Component({
  selector: 'app-turn',
  templateUrl: 'turn.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class Turn {

  @Input() turns: TurnEntity[];
  @Input() sites: SiteEntity[];
  @Input() modalities: ModalityEntity[];
  @Input() coursesType: CourseTypeEntity[];
  @Input() courses: CourseEntity[];

  @Input() commonCourse: CommonCourseDto;

  @Output() filter = new EventEmitter<number>();

  aux: SiteEntity[];
  roles: BasicDto[];
  staticCalendars: StaticCalendarEntity[];
  staticCalendarsFiltered: StaticCalendarEntity[];

  newEntity: TurnEntity;
  modeAdd = false;

  showStartDate = false;
  showEndDate = false;
  showOpenSignupDate = false;
  showCloseSignupDate = false;
  showSettings = false;
  showCustomize = false;

  currentTurn: TurnEntity;
  currentCourseFrontPage: CourseFrontPageEntity;

  availableParents: any = [];
  permissionSettings = false;

  parentId: number;
  parentType: string;
  currentParentRole: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: true,
    placeholder: 'Enter text here...',
    fonts: [
      {class: 'arial', name: 'Arial'},
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['indent', 'outdent', 'superscript', 'subscript', 'link', 'unlink', 'insertImage', 'insertVideo', 'strikeThrough', 'fontName'],
    ]
  };

  headers: any = {
    columns: {
      id: {title: 'Statement', hide: true, filter: false},
      alias: {title: 'Alias', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.alias = data.text;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      name: {title: 'Name', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.name = data.text;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      siteId: {title: 'Site', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.aux}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.siteId = data.id;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      startDate: {
        title: 'Start date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.startDate = data.date;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      endDate: {
        title: 'End date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.endDate = data.date;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      openSignupDate: {
        title: 'Open signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.openSignupDate = data.date;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      closeSignupDate: {
        title: 'Close signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.closeSignupDate = data.date;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      defaultRole: {
        title: 'Default role', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: cell, options: this.roles}
        },
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.defaultRole = data.id;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      contentNotification: {
        title: 'Content notification', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.contentNotification = data.bool;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      showInRegister: {
        title: 'Show in Register', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.showInRegister = data.bool;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      showInCampus: {
        title: 'Show in Campus', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.showInCampus = data.bool;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      showInMagnament: {
        title: 'Show in Magnament', hide: true, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let turn = this.turns.find(x => x.id == data.row.id)
              turn.showInMagnament = data.bool;
              this.saveTurn(turn, false);
            });
          }
        },
      },
      corpId: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'brush-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.customizeCourse(data);
              this.showCustomize = true;
            });
          }
        },
      },
      row2: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'copy-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.cloneTurn(data);
            });
          }
        },
      },
      row3: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'settings-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.openSettingsDiv(data);
              this.showSettings = true;
            });
          }
        },
      },
      row4: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'shield-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              let turn = this.turns.find(x => x.id == data);
              this.parentType = 'TURN';
              this.parentId = turn.id;
              this.currentParentRole = turn.defaultRole;
              this.permissionSettings = true;
            });
          }
        },
      },
    },
    actions: false,
  }

  constructor(private courseService: CourseService, private contextService: ContextService, private shared: Shared) {
  }

  ngOnInit() {
    this.aux = this.sites.map(x=> {
      let modality = this.modalities.find(p=> p.id == x.modalityId);
      let courseType = this.coursesType.find(y=> y.id == modality.courseTypeId)
      let course = this.courses.find(p=> p.id == courseType.courseId);
      x.name = x.name+" ("+modality.alias+" - "+courseType.alias+" - "+course.alias+")";
      return x;
    });

    this.roles = this.commonCourse.roles;
    this.staticCalendars = this.commonCourse.staticCalendars;
    this.staticCalendars.forEach(item => {
      item.alias = item.name;
    });
  }

  customizeCourse(id: number) {
    this.currentTurn = this.turns.find(x => x.id == id);
    this.currentCourseFrontPage = new CourseFrontPageEntity();
    this.currentCourseFrontPage.corpId = this.shared.CORP_ID;
    this.currentCourseFrontPage.turnId = id;
    this.currentCourseFrontPage.html = "";
    this.currentCourseFrontPage.backgroundImage = "";
    this.currentCourseFrontPage.enabled = true;
    this.courseService.getCourseFrontPageByTurn(this.currentTurn.id).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
  }

  openSettingsDiv(id){
    this.currentTurn = this.turns.find(p=> p.id == id);
    let s = this.sites.find(p=> p.id == this.currentTurn.siteId);
    let m = this.modalities.find(p=> p.id == s.modalityId);
    let ct = this.coursesType.find(p=> p.id == m.courseTypeId);
    let c = this.courses.find(p=> p.id == ct.courseId);

    this.staticCalendarsFiltered = this.staticCalendars.filter(x => x.courseId == c.id || x.courseId == null);

    this.availableParents.push({'id':c.id, 'name':c.name, 'type': "COURSE"});
    this.coursesType.filter(ctS=>ctS.courseId == c.id).forEach(ct=>{
      this.availableParents.push({'id': ct.id, 'name': "--"+ct.name, 'type': "COURSE_TYPE"});
      this.modalities.filter(mS=> mS.courseTypeId == ct.id).forEach(m=>{
        this.availableParents.push({'id': m.id, 'name': "-- -- "+m.name, 'type': "MODALITY"});
        this.sites.filter(sS=> sS.modalityId == m.id).forEach(s=>{
          this.availableParents.push({'id': s.id, 'name': "-- -- -- "+s.name, 'type': "SITE"});
          this.turns.filter(tS=> tS.siteId == s.id).forEach(t=>{
            this.availableParents.push({'id': t.id, 'name': "-- -- -- -- "+t.name, 'type': "TURN"});
          })
        })
      })
    })
  }

  saveCourseFrontPage() {
    this.courseService.saveCourseFrontPage(this.currentCourseFrontPage).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
    this.currentTurn = null;
    this.showCustomize = false;
  }


  cloneTurn(id){
    let bool = confirm("¿Estás seguro que deseas duplicar el turno?");

    if(bool) {
      this.courseService.cloneTurn(id).subscribe((w: TurnEntity[]) => {
        if (w != null) {
          this.turns = w;
        }
      });
    }
  }

  saveTurn(turn: TurnEntity, bool) {
    if(turn.name.indexOf('(')!=-1) {
      turn.name = turn.name.substr(0,turn.name.indexOf('('));
    }
    this.courseService.saveTurn(turn).subscribe( t =>{
      if(t!=null) {
        if(bool){this.turns.push(t);}
        this.turns = this.turns.filter(x => {return x});
      }
    });
  }

  async saveNewTurn() {
    this.saveTurn(this.newEntity, true);
    this.modeAdd = false;
  }

  newTurn(){
    this.modeAdd = true;
    this.newEntity = new TurnEntity();
    this.newEntity.corpId = this.shared.CORP_ID;
    this.newEntity.showInMagnament = true;
  }

  changeStartDate(event){
    this.newEntity.startDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeEndDate(event){
    this.newEntity.endDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeOpenSingupDate(event){
    this.newEntity.openSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeCloseSingupDate(event){
    this.newEntity.closeSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  nextStep(id: number){
    this.filter.emit(id);
  }

  convertFileToBase64DocumentB(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.backgroundImage = reader.result.toString();
    };
  }

  convertFileToBase64DocumentS(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.subscriptionImage = reader.result.toString();
    };
  }

  async closePermissionsWindow(data: PermissionRoleEntity[]){
    this.permissionSettings = false;
    this.roles = null;
    await this.delay(200);
    this.roles = data.map(d=> new BasicDto(d.id, d.alias, d.name, null));
  }

  splitByComma(text) {
    if (text != null) {
      return text.split(',');
    }
    return null;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
